"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var GMAPI_KEY = 'AIzaSyCnr6pYRa8qgqrXZmfFkwGwfhkyJMF601o';
var MAP_SRC = "https://maps.googleapis.com/maps/api/js?key=" + GMAPI_KEY + "&zoom=12&format=png&maptype=roadmap&style=element:geometry%7Ccolor:0xf5f5f5&style=element:labels.icon%7Cvisibility:off&style=element:labels.text.fill%7Ccolor:0x616161&style=element:labels.text.stroke%7Ccolor:0xf5f5f5&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd&style=feature:poi%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:poi.park%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:road%7Celement:geometry%7Ccolor:0xffffff&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161&style=feature:road.local%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&size=480x360&callback=mapLoaded";
var mapLoad = null;

function loadMap() {
  if (!mapLoad) {
    mapLoad = new Promise(function (resolve) {
      window.mapLoaded = function () {
        resolve(true);
      };

      var script = document.createElement('script');
      script.async = true;
      script.src = MAP_SRC;
      document.body.insertBefore(script, document.body.firstChild);
    });
  }

  return mapLoad;
}

var GoogleMap =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(GoogleMap, _Component);

  function GoogleMap(props) {
    var _this;

    babelHelpers.classCallCheck(this, GoogleMap);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(GoogleMap).call(this, props));
    _this.state = {
      map: null
    };
    _this.onResize = _this.onResize.bind(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.gotMapRoot = _this.gotMapRoot.bind(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.recenterMap = _this.recenterMap.bind(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    GoogleMap.currentInstance = babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  babelHelpers.createClass(GoogleMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', this.onResize);
      loadMap().then(function () {
        _this2.getCoordinates().then(function (data) {
          _this2.setState({
            mapData: data
          }, function () {
            _this2.setupMap();
          });
        });
      });
    }
  }, {
    key: "geocode",
    value: function geocode(address) {
      return new Promise(function (resolve) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          address: address
        }, function (result, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            resolve(result[0].geometry.location);
          } else {
            resolve({
              lat: 0,
              lng: 0
            });
          }
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.mapRoot && this.state.mapElement && this.state.mapElement.parentNode != this.mapRoot) {
        this.mapRoot.appendChild(this.state.mapElement);
        this.onResize();
      }
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      var _this3 = this;

      var C = [];

      for (var i = 0; i < this.props.data.length; i++) {
        var item = this.props.data[i];
        C.push(this.geocode(item.address));
      }

      return Promise.all(C).then(function (coords) {
        var b = new google.maps.LatLngBounds(coords[0], coords[0]);

        for (var _i = 2; _i < coords.length; _i++) {
          b = b.extend(coords[_i]);
        }

        return {
          bounds: b,
          center: b.getCenter(),
          data: coords.map(function (coordinates, item) {
            return babelHelpers.objectSpread({}, _this3.props.data[item], {
              coordinates: coordinates
            });
          })
        };
      });
    }
  }, {
    key: "onResize",
    value: function onResize() {
      if (this.mapRoot && this.state.mapElement) {
        google.maps.event.trigger(this.state.map, 'resize');
        requestAnimationFrame(this.recenterMap);
      }
    }
  }, {
    key: "recenterMap",
    value: function recenterMap() {
      var nc = document.querySelector('.navigation-container');
      this.state.map.fitBounds(this.state.mapData.bounds, {
        top: nc.offsetTop + nc.offsetHeight + 96,
        left: 32,
        right: 32,
        bottom: 0
      });
    }
  }, {
    key: "setupMap",
    value: function setupMap() {
      var _this4 = this;

      loadMap().then(function () {
        return _this4.setupMapInner();
      });
    }
  }, {
    key: "setupMapInner",
    value: function setupMapInner() {
      if (!this.state.mapData) return;
      var mapCenter = this.state.mapData.center;
      var mapOptions = {
        center: mapCenter,
        zoom: 17,
        clickableIcons: false,
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        draggable: false,
        fullscreenControl: false,
        gestureHandling: 'none',
        keyboardShortcuts: false,
        mapTypeControl: false,
        panControl: false,
        rotateControl: false,
        scaleControl: false,
        scrollwheel: false,
        streetViewControl: false,
        zoomControl: false,
        styles: [{
          stylers: [{
            saturation: -100
          }, {
            gamma: 0.8
          }, {
            lightness: 2
          }, {
            visibility: 'on'
          }]
        }]
      };
      var mapElement = document.createElement('div');
      mapElement.className = 'gmap-container';

      if (this.state.mapElement) {
        this.state.mapElement.remove();
      }

      this.mapRoot.appendChild(mapElement);
      var map = new google.maps.Map(mapElement, mapOptions);
      var markers = this.state.mapData.data.map(function (item) {
        var m = new google.maps.Marker({
          position: item.coordinates,
          map: map,
          icon: {
            url: "/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/new-home/psh-anchor.png"
          }
        });
        m.addListener('click', function (event) {
          location.href = item.href;
        });
        return m;
      });
      this.setState({
        map: map,
        mapElement: mapElement,
        mapOptions: mapOptions
      });
      this.onResize();
    }
  }, {
    key: "gotMapRoot",
    value: function gotMapRoot(node) {
      var oldMapRoot = this.mapRoot;
      this.mapRoot = node;

      if (oldMapRoot != this.mapRoot) {
        this.setupMap();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "map-outer"
      }, _react.default.createElement("div", {
        className: "google-map",
        ref: this.gotMapRoot
      }));
    }
  }], [{
    key: "show",
    value: function show(data, parent) {
      _reactDom.default.render(_react.default.createElement(GoogleMap, {
        data: data
      }), parent);
    }
  }]);
  return GoogleMap;
}(_react.Component);

exports.default = GoogleMap;